import { useCallback, useEffect, useState } from "react";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import Screenshot from "@/domains/screenshot/entities/Screenshot";
import {
  ScreenshotShotRequest,
  screenshotTypeExtension,
  screenshotTypeMime,
} from "@/domains/screenshot/types/screenshot.types";

export default function useGetScreenshoot() {
  const [image, setImage] = useState<string | null>(null);

  const house = useCallback(async (blob: Blob, houseId: number) => {
    const formData = new FormData();

    // Добавляем изображение в FormData. Можно указать имя поля (например, 'file'), чтобы сервер мог правильно его обработать
    formData.append("houseId", String(houseId));
    formData.append("file", blob, "image.jpg");
    // formData.append("file2", blob, "image2.png");

    const apiUrl = `${import.meta.env.VITE_SCREENSHOT_URL}/v1/screenshot/house/${houseId}`;

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("response error:", response.status, errorText);
    } else {
      console.log("response ok:", response.status);
    }
  }, []);

  const characterDocuments = useCallback(async (blob: Blob, token: string) => {
    const formData = new FormData();

    formData.append("file", blob, "image.webp");

    const apiUrl = `${import.meta.env.VITE_SCREENSHOT_URL}/v1/screenshot/document/photo`;

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("response error:", response.status, errorText);
      return false;
    }

    console.log("response ok:", response.status);
    return true;
  }, []);

  const handle = useCallback(
    async (data: ScreenshotShotRequest): Promise<void> => {
      console.log(JSON.stringify({ screenshot: data }));

      const fullFileName = [data.fileName, screenshotTypeExtension[data.type]].join(".");
      const url = ["http://screenshots", fullFileName].join("/");

      const response = await fetch(url, {
        mode: "no-cors",
      });

      if (!response.ok) {
        console.log(`Can't load image from screenshots: ${response.statusText}`);
        return;
      }

      const blob = await response.blob();
      const screenshot: Screenshot = new Screenshot(blob, data.type);

      const base64 = await screenshot.getBase64();

      const mime = screenshotTypeMime[data.type];

      setImage(`data:${mime};base64,${base64}`);

      // const content = await screenshot.getNumberArray();
      // const content = await screenshot.getBase64();

      // await ping().catch((err) => console.error(err));
      try {
        if (data.name === "House") {
          await house(blob, data.id);
        }

        if (data.name === "CharacterDocuments") {
          if (!data.payload) {
            return;
          }

          const { token } = data.payload;
          if (!token) {
            return;
          }

          await characterDocuments(blob, token);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setImage(null);
      }

      // await RpcMpProvider.getInstance().callServer("ScreenshotHouse", {
      //   type: mime,
      //   content: [1, 2, 3],
      // });
      //
      // console.log({ data2: data, fullFileName });
    },
    [characterDocuments, house],
  );

  useEffect(() => {
    const unsubscribe = RpcMpProvider.getInstance().subscribe("ScreenshotShot", handle);

    return () => {
      unsubscribe();
    };
  }, [handle]);

  return { image, characterDocuments };
}
